import { useEffect, useState } from 'react';
import { BehaviorSubject, type Observable, timer } from 'rxjs';
import { concatMap, switchMap } from 'rxjs/operators';

export function nullOrWhitespace(str: string | null) {
  return str === null || str.trim() === '';
}

export const useSubscription = (observable: Observable<any>, initial: any) => {
  const [data, setData] = useState(initial);

  useEffect(() => {
    const subscription = observable.subscribe((subData) => setData(subData));

    return () => subscription.unsubscribe();
  }, []);

  return data;
};

export const usePollingSubscription = (observer: Observable<any>, initialValue: any, timeout: number) => {
  const [data, setData] = useState(initialValue);
  const [triggerSubject] = useState(new BehaviorSubject(''));

  useEffect(() => {
    const subscription = triggerSubject
      .pipe(switchMap((_) => timer(0, timeout).pipe(concatMap(() => observer))))
      .subscribe((subData) => setData(subData));

    return () => subscription.unsubscribe();
  }, []);

  return [data, () => triggerSubject.next('')];
};
